import { render } from "./Family.component.vue?vue&type=template&id=050bf6aa"
import script from "./Family.component.vue?vue&type=script&lang=js"
export * from "./Family.component.vue?vue&type=script&lang=js"

import "./Family.component.vue?vue&type=style&index=0&id=050bf6aa&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__